// converts a time from a trimmed video to the correlating time of the
// full video
//
// all times in *milliseconds*
export const convertTrimTimeToFullTime = (time, trimRanges) => {
  let accumulatedShift = 0;

  trimRanges.some(({ from, to }) => {
    if (from > time + accumulatedShift) {
      return true;
    }

    // this segment is part of the full video - add its length
    accumulatedShift += to - from;
  });

  return time + accumulatedShift;
};

// converts a time from a full video to the correlating time of the
// trimmed video (or NaN if the time doesn't exist in the trimmed video)
//
// all times in *milliseconds*
export const convertFullTimeToTrimTime = (time, trimRanges) => {
  let shiftedTime = time;

  trimRanges.some(({ from, to }) => {
    // only exclude if the comment is fully outside the trim range at the second
    // marks, since comment time is rounded to nearest second unlike trim ranges
    // which are to nearest millisecond
    const compareFrom = Math.ceil(from / 1000) * 1000;
    const compareTo = Math.floor(to / 1000) * 1000;

    // compare using >, not >=, so time on the "to" edge still works
    if (compareFrom <= time && compareTo > time) {
      shiftedTime = NaN;

      return true;
    }

    if (compareFrom > time) {
      return true;
    }

    // this segment is not part of the trimmed video - subtract its length
    shiftedTime -= to - from;
  });

  // because we are loose with comparisons, shiftedTime can be a small negative number
  return Math.max(shiftedTime, 0);
};

export const getTrimVideoDuration = (fullDuration, trimRanges) => {
  return trimRanges.reduce((totalTime, trimRange) => {
    return totalTime - (trimRange.to - trimRange.from) / 1000;
  }, fullDuration);
};

export const getTrimEventProperties = (video, trimRanges, duration = null) => {
  const { duration: fullDuration = duration } = video.video_properties;

  if (fullDuration == null) {
    return;
  }

  const trimmedDuration = getTrimVideoDuration(fullDuration, trimRanges);

  const trackProperties = {
    percentage_trimmed: Math.floor((trimmedDuration / fullDuration) * 100),
    trimmed_video_duration: parseFloat(trimmedDuration.toFixed(1)),
    video_id: video.id,
    organization_id: video.organization_id,
    video_duration: parseFloat(fullDuration.toFixed(1)),
    waveform_generation: video.waveform_generation,
    has_been_trimmed: trimRanges.length > 0,
    event_type: 'click',
  };

  // get percentile information for every 10% of the video trimmed out
  [...Array(10)].forEach((val, index) => {
    const percentileLower = index / 10;
    const percentileUpper = (index + 1) / 10;

    const lowerBound = percentileLower * fullDuration * 1000;
    const upperBound = percentileUpper * fullDuration * 1000;

    let percentileTrimmed = false;

    trimRanges.some(({ from, to }) => {
      if (from > upperBound) {
        return true;
      }

      if (from <= upperBound && to >= lowerBound) {
        percentileTrimmed = true;

        return true;
      }
    });

    trackProperties[`trim_percentile_${index * 10 + 10}`] = percentileTrimmed;
  });

  return trackProperties;
};
